<template lang='pug' src='./MenuCalendar.pug'></template>

<script>
  import Vue from 'vue'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'MenuCalendar',
    data: function () {
      return {
        kaleidersCalendar: Vue.config.holidays.KALEIDERS_CALENDAR,
        AVAILABLE_DAYS: 'available days',
        BOOKED_HOLIDAY: 'Booked holiday',
        PUBLIC_HOLIDAY: 'Public holiday',
        IMPORT_SUCCESS: 'Holidays updated :)',
        shrinkedTitle: false,
        editYear: false,
        currentYear: new Date().getFullYear(),
        lastYear: new Date().getFullYear() - 1
      }
    },
    props: {
      showBookedHolidays: {
        type: Boolean,
        default: true
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
      document.addEventListener('click', this.handleClick)
    },
    destroyed () {
      document.removeEventListener('click', this.handleClick)
      window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {
      getUpdateVacations: function (val) {
        this.me()
      }
    },
    computed: {
      ...mapGetters([
        'getMe',
        'getSelectedYear',
        'getUpdateVacations',
        'getImportSuccess'
      ]),
      yearList () {
        let years = [new Date().getFullYear() + 1]
        for (let i = 0; i < 3; i++) {
          years.push(new Date().getFullYear() - i)
        }
        return years
      },
      allYearsNum () {
        let years = []

        this.getMe.daysPerYear.reduce((reducer, valorActual) => {
          if (valorActual.remainingDays) {
            reducer.push({
              year: valorActual.year.toString(),
              num: valorActual.remainingDays,
              info: valorActual.holidayType
            })
          }

          return reducer
        }, years)

        return years.sort().reverse()
      }
    },
    methods: {
      ...mapActions([
        'setSelectedYear',
        'me',
        'importHolidays',
        'setImportHolidaysSuccess'
      ]),
      handleClick (ev) {
        if (
          !this.$refs.dropdown.contains(ev.target) &&
          !this.$refs.arrow.contains(ev.target)
        ) {
          this.editYear = false
        }
      },
      handleScroll () {
        const distanceY = window.pageYOffset || document.documentElement.scrollTop
        const shrinkOn = 80
        const shrinkOff = 1
        const headerEl = document.querySelector('.titleCalendarContainer')

        if ((!this.shrinkedTitle) && (distanceY > shrinkOn)) {
          this.shrinkedTitle = true
          headerEl.classList.add('smaller')
        } else if ((this.shrinkedTitle) && (distanceY < shrinkOff)) {
          this.shrinkedTitle = false
          headerEl.classList.remove('smaller')
        }
      },
      showYear () {
        this.editYear = !this.editYear
      },
      changeYear (year) {
        this.setSelectedYear(year)
        this.showYear()
        this.me()
      },
      importCalendar () {
        this.importHolidays()
      },
      changeSuccess () {
        this.setImportHolidaysSuccess(false)
      }
    }
  }
</script>

<style lang='css' src='./MenuCalendar.css' scoped></style>



// WEBPACK FOOTER //
// MenuCalendar.vue?a1dcce2e